let menuIsCollapsed = true;

export function dropDown() {
    menuIsCollapsed ? expandMenu() : collapseMenu();

    function expandMenu() {
        $w('#drop1, #drop2, #topMargin').expand();
        $w('#dropDownIcon').hide();
        $w('#dropIconUp').show();
        menuIsCollapsed = !menuIsCollapsed;
    }

    function collapseMenu() {
        $w('#drop1, #drop2,#topMargin').collapse();
        $w('#dropDownIcon').show();
        $w('#dropIconUp').hide();
        menuIsCollapsed = !menuIsCollapsed;
    }

}